import { render } from "./UserCreateEditDialog.vue?vue&type=template&id=b9742ad8&scoped=true&ts=true"
import script from "./UserCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./UserCreateEditDialog.vue?vue&type=script&lang=ts"

import "./UserCreateEditDialog.vue?vue&type=style&index=0&id=b9742ad8&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9742ad8"]])

export default __exports__